import { track } from 'src/tracking/trackingService';

const EVENT_PREFIX = 'marketing.management.facebook_business_extension';

export const FacebookBusinessExtensionAnalytics = {
  trackUninstallClicked: () => {
    track(`${EVENT_PREFIX}.uninstall.clicked`);
  },
};
